import router from './router'
import store from './store'
import { hasSupplierRole } from '@/utils/shareDemandAuth'
import { isAuthenticated } from '@/utils/auth'
import { resolveServerAccess } from '@/utils/serverAccess'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false })

function isShareDemandDetail(to) {
  const isDetailPage = to.name === 'demandCardDetail' || to.path === '/supplySide/demandCardDetail'
  if (!isDetailPage) {
    return false
  }
  if (to.query && (to.query.share === '1' || to.query.share === 1)) {
    return true
  }
  return /[?&]share=1(?:&|#|$)/.test(window.location.href)
}

function canAccessShareDemandDetail() {
  return isAuthenticated() && store.state.isRole == 2
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  try {
    const accessResult = await resolveServerAccess()
    if (accessResult.needAuth) {
      if (to.path === '/login' && to.query.serverAccess !== '1') {
        next({
          path: '/login',
          query: { ...to.query, serverAccess: '1' },
          replace: true
        })
        return
      }
      if (to.path !== '/login') {
        next({
          path: '/login',
          query: {
            serverAccess: '1',
            redirect: to.fullPath
          },
          replace: true
        })
        return
      }
    }
  } catch (e) {
    console.error('[permission] server access check failed', e)
  }

  if (isShareDemandDetail(to) && !canAccessShareDemandDetail()) {
    const redirectPath = to.fullPath

    if (store.state.isLoggedIn == 1 || isAuthenticated()) {
      if (hasSupplierRole(store.state.userInfo)) {
        next({
          path: '/',
          query: {
            shareSwitch: '1',
            redirect: redirectPath
          },
          replace: true
        })
        return
      }

      next({
        path: '/login',
        query: {
          redirect: redirectPath,
          shareTip: '1'
        },
        replace: true
      })
      return
    }

    next({
      path: '/login',
      query: {
        redirect: redirectPath,
        shareTip: '1'
      },
      replace: true
    })
    return
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js